import {
  mdiPollBox,
  mdiPoll,
  mdiHistory,
  mdiHelpCircleOutline,
  mdiAccountGroup,
  mdiAccount,
  mdiCog,
  mdiInformationOutline,
  mdiFormatQuoteClose,
  mdiCalendarToday,
  mdiAttachment,
  mdiChatOutline,
  mdiSendOutline,
  mdiCurrencyEur,
  mdiChatQuestionOutline,
  mdiMonitor,
  mdiSitemap,
  mdiDomain
} from '@mdi/js'

export default [
  {
    title: 'Uutiset',
    icon: mdiFormatQuoteClose,
    to: 'admin-news-list',
    dynamicTitle: true,
    dynamicTitleKey: 'news'
  },
  {
    title: 'Tapahtumat',
    icon: mdiCalendarToday,
    to: 'admin-event-list',
  },
  {
    title: 'Kyselyt',
    icon: mdiPoll,
    to: 'admin-poll-list',
  },
  {
    title: 'Uusi kyselytyökalu',
    icon: mdiPollBox,
    to: 'admin-survey-list',
  },
  {
    title: 'Tiedostot',
    icon: mdiAttachment,
    to: 'admin-resource-list',
  },
  {
    title: 'Kysymykset & vastaukset',
    icon: mdiChatQuestionOutline,
    to: 'admin-faq-list',
    tenantAdmin: true
  },
  {
    title: 'Palautekanava',
    icon: mdiSendOutline,
    to: 'admin-feedback-list',
    feedbackManager: true,
    adminNotificationKey: 'newFeedbackCount'
  },
  {
    title: 'Meidän yritys',
    icon: mdiInformationOutline,
    to: 'admin-page-list',
    dynamicTitle: true,
    dynamicTitleKey: 'our_company',
    tenantAdmin: true
  },
  {
    title: 'Henkilöstöedut',
    icon: mdiCurrencyEur,
    to: 'admin-benefit-list',
    optional: true,
    optional_key: 'benefits_enabled',
    tenantAdmin: true
  },
  {
    title: 'Keskustelukanavat',
    icon: mdiChatOutline,
    to: 'admin-chat-channel-list',
    optional: true,
    optional_key: 'chat_enabled',
    tenantAdmin: true
  },
  {
    subheader: 'InfoTV',
    tenantAdmin: true,
    optional: true,
    optional_key: 'infotv_enabled',
  },
  {
    title: 'Näytöt',
    icon: mdiMonitor,
    to: 'admin-infotv-screens',
    tenantAdmin: true,
    optional: true,
    optional_key: 'infotv_enabled',
  },
  {
    subheader: 'Ylläpito',
    tenantAdmin: true
  },
  {
    title: 'Käyttäjät',
    icon: mdiAccount,
    to: 'admin-user-list',
    tenantAdmin: true
  },
  {
    title: 'Ryhmät',
    icon: mdiAccountGroup,
    to: 'admin-groups',
    tenantAdmin: true
  },
  {
    title: 'Osastot',
    icon: mdiSitemap,
    to: 'admin-settings-departments',
    tenantAdmin: true
  },

  // {
  //   title: 'Asetukset',
  //   icon: mdiCog,
  //   to: 'admin-settings-hub',
  //   tenantAdmin: true
  // },
  {
    title: 'Ulkoasuasetukset',
    icon: mdiDomain,
    to: 'admin-company-settings',
    tenantAdmin: true
  },
  {
    title: 'Palauteasetukset',
    icon: mdiCog,
    to: 'admin-settings',
    tenantAdmin: true
  },
  {
    title: 'Julkaisuasetukset',
    icon: mdiCog,
    to: 'admin-publishing-settings',
    tenantAdmin: true
  },
  {
    subheader: 'Tietoja',
    tenantAdmin: true
  },
  {
    title: 'Ohjeet',
    icon: mdiHelpCircleOutline,
    to: 'admin-support',
    tenantAdmin: true
  },
  {
    title: 'Päivitykset',
    icon: mdiHistory,
    to: 'admin-changelog',
    tenantAdmin: true
  },
]
